// extracted by mini-css-extract-plugin
module.exports = {"article":"GridArticle_article__i2FJK"};